import { useState, useEffect, useRef  } from "react";
import { FaSearch } from "react-icons/fa";
import { GrClose } from "react-icons/gr";

export const Search = ({ link, setResults, input, setInput, home, containerRef }) => {
  const currentSearchId = useRef(0);

  const fetchData = async (value, searchId, signal) => {
    try {
      const response = await fetch(`${link}${value}`, { signal });
      if (!response.ok) {
        throw new Error("Ошибка при выполнении запроса");
      }
      const json = await response.json();
      // Проверяем, что результаты соответствуют текущему поиску
      if (searchId === currentSearchId.current) {
        const results = json.filter((user) => {
          return (
            value &&
            user &&
            user.name 
          );
        });
        setResults(results);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        // Запрос отменён новым вводом пользователя — это ожидаемое поведение, не ошибка
        return;
      }
      console.error(error);
    }
  };

  const handleChange = (value) => {
    setInput(value);

    // Увеличиваем значение currentSearchId через .current
    currentSearchId.current++;

    // Отменяем предыдущий запрос
    const previousSearchId = currentSearchId.current - 1;
    if (fetchDataController[previousSearchId]) {
      fetchDataController[previousSearchId].abort();
    }

    // Пустой запрос — не дёргаем сервер, просто прячем список результатов
    if (!value.trim()) {
      setResults([]);
      const list = containerRef?.current?.querySelector(".results-list");
      if (list) list.classList.add("none");
      return;
    }

    // Создаем новый контроллер для текущего запроса и реально привязываем его к fetch через signal
    const controller = new AbortController();
    fetchDataController[currentSearchId.current] = controller;

    // Выполняем новый запрос
    fetchData(value.toLowerCase(), currentSearchId.current, controller.signal);

    const list = containerRef?.current?.querySelector(".results-list");
    if (list && list.classList.contains("none")) {
      list.classList.remove("none");
    }
  };

  const handleClear = () => {
    setInput("");
    // Увеличиваем значение currentSearchId через .current
    currentSearchId.current++;

    // Отменяем предыдущий запрос
    const previousSearchId = currentSearchId.current - 1;
    if (fetchDataController[previousSearchId]) {
      fetchDataController[previousSearchId].abort();
    }

    setResults([]);
  };

  useEffect(() => {
    // Очищаем результаты поиска при размонтировании компонента
    return () => {
      setResults([]);
    };
  }, []);

  return (
    <div className={home ? "input-wrapper" : "mini-input-wrapper"}>
      {home && <FaSearch id="search-icon" />}
      <input
        placeholder="Поиск..."
        value={input}
        onChange={(e) => handleChange(e.target.value)}
      />
      <GrClose id="close-icon" onClick={handleClear} />
    </div>
  );
};

// Объект для отслеживания контроллеров запросов
const fetchDataController = {};